import { gql } from "@apollo/client"

export const FETCH_TEAMS = gql`
  query {
    teams { id, name, footballId, crest, crestLink}
  }
`;
